import React from 'react';
import { Link } from 'react-router-dom';
import './locations.css';

const Locations = () => {
  const locations = [
    { name: 'Pune', link: '/home-inspection-pune' },
    { name: 'Mumbai', link: '/home-inspection-mumbai' },
    { name: 'Navi Mumbai', link: '/home-inspection-mumbai' },
    { name: 'Thane', link: '/home-inspection-mumbai' },
    { name: 'Lonavala', link: '/home-inspection-lonavala' },
    { name: 'Bangalore', link: '/home-inspection-bangalore' },
    { name: 'Chennai', link: '/home-inspection-chennai' },
  ];

  return (
    <section className="locations-section">
      <div className="locations-container">
        <div className="locations-header">
          <span className="locations-icon">📍</span>
          <h3 className="locations-title">We Serve:</h3>
        </div>
        <div className="locations-list">
          {locations.map((location, index) => (
            location.link ? (
              <Link key={index} to={location.link} className="location-item location-link">
                {location.name}
              </Link>
            ) : (
              <div key={index} className="location-item">
                {location.name}
              </div>
            )
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;

